import { useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom"
import { createQueryString, queryStringToObject } from "../../utils";

const useUrlParams = () => {
    const { search } = useLocation();
    const history = useHistory();

    const urlParams = useMemo(() => queryStringToObject(search), [search]);

    const setUrlParams = ({ replace, ...obj}) => {
        if (replace) {
            history.replace({
                search: createQueryString(obj)
            });
        } else {
            history.push({
                search: createQueryString(obj)
            });
        }
    };

    return { urlParams, setUrlParams };
};

export { useUrlParams };